<script setup>
    import { computed } from 'vue';
    import { useStore } from 'vuex';
    import AlertDetails from '@/components/common/AlertDetails.vue';

    const store = useStore();
    const user = store.state.user;

    const hasAccess = computed(() => {
        return user && (
            user.role === 'admin' ||
            (user.permissions && (
                user.permissions.includes('viewAllAlerts') ||
                user.permissions.includes('editAllAlerts') ||
                user.permissions.includes('deleteAllAlerts')
            ))
        );
    });
</script>


<template>
    <div v-if="!hasAccess" class="flex flex-col items-center justify-center h-full">
        <h1 class="text-3xl md:text-5xl my-4 md:my-6 font-bold text-mc-red">Access Denied</h1>
        <p class="text-xl text-ink-muted dark:text-on-dark-muted">You do not have permission to access this page.</p>
        <p class="text-lg text-ink-muted dark:text-on-dark-muted mt-2">Required permissions:
            <span class="font-mono bg-mc-steel/30 dark:bg-white/10 px-2 py-1 rounded-mc-sm text-mc-ink dark:text-on-dark">viewAllAlerts</span>,
            <span class="font-mono bg-mc-steel/30 dark:bg-white/10 px-2 py-1 rounded-mc-sm text-mc-ink dark:text-on-dark">editAllAlerts</span>, or
            <span class="font-mono bg-mc-steel/30 dark:bg-white/10 px-2 py-1 rounded-mc-sm text-mc-ink dark:text-on-dark">deleteAllAlerts</span>
        </p>
    </div>
    <template v-else>
        <p class="mt-4 text-xs font-semibold uppercase tracking-wide text-ink-muted dark:text-on-dark-muted">Manage</p>
        <h1 class="text-2xl font-bold text-mc-ink dark:text-on-dark mb-1">Alerts</h1>
        <p class="mb-3 text-sm text-ink-muted dark:text-on-dark-muted">Review and tune alert behavior for day-to-day operations.</p>
        <AlertDetails />
    </template>
</template>
